/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdNewPlanPostRequest model module.
 * @module model/CustomersIdNewPlanPostRequest
 * @version 1.0.0
 */
class CustomersIdNewPlanPostRequest {
    /**
     * Constructs a new <code>CustomersIdNewPlanPostRequest</code>.
     * @alias module:model/CustomersIdNewPlanPostRequest
     * @param serviceId {Number} 
     * @param accountId {Number} 
     * @param productId {Number} 
     */
    constructor(serviceId, accountId, productId) { 
        
        CustomersIdNewPlanPostRequest.initialize(this, serviceId, accountId, productId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, serviceId, accountId, productId) { 
        obj['serviceId'] = serviceId;
        obj['accountId'] = accountId;
        obj['productId'] = productId;
    }

    /**
     * Constructs a <code>CustomersIdNewPlanPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdNewPlanPostRequest} obj Optional instance to populate.
     * @return {module:model/CustomersIdNewPlanPostRequest} The populated <code>CustomersIdNewPlanPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdNewPlanPostRequest();

            if (data.hasOwnProperty('serviceId')) {
                obj['serviceId'] = ApiClient.convertToType(data['serviceId'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('productId')) {
                obj['productId'] = ApiClient.convertToType(data['productId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdNewPlanPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdNewPlanPostRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomersIdNewPlanPostRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CustomersIdNewPlanPostRequest.RequiredProperties = ["serviceId", "accountId", "productId"];

/**
 * @member {Number} serviceId
 */
CustomersIdNewPlanPostRequest.prototype['serviceId'] = undefined;

/**
 * @member {Number} accountId
 */
CustomersIdNewPlanPostRequest.prototype['accountId'] = undefined;

/**
 * @member {Number} productId
 */
CustomersIdNewPlanPostRequest.prototype['productId'] = undefined;






export default CustomersIdNewPlanPostRequest;

